export enum BulkActionStatus {
    Pending = 'Pending',
    Success = 'Success',
    Processing = 'Processing',
    Failed = 'Failed',
    Completed = 'Completed'
}

export enum BulkActionType {
    Import = 'Import',
    Update = 'Update',
    Export = 'Export'
}